import {Fragment, PureComponent} from 'react'
import PropTypes from 'prop-types'
import nl2br from "react-nl2br"
import Plus from 'react-feather/dist/icons/plus.js'
import Edit from 'react-feather/dist/icons/edit.js'
import Trash from 'react-feather/dist/icons/trash.js'

import conf from "../../../../conf.js"
import api from "../../../../../api.js"
import { parseISO, isAfter } from 'date-fns'

import SummaryStepForm from "../../../../../shared/components/Forms/SummaryStep/SummaryStepForm.jsx"
import SummaryStepSubmit from "../../../../../shared/components/Forms/SummaryStep/Submit.jsx"
import connectModal from "../../../../../shared/components/Modals/connect.js"
import DiplomeModal from "../../../../../shared/components/Modals/Diplome/DiplomeModal.jsx"
import DeleteDiplomeModal from "../../../../../shared/components/Modals/Diplome/DeleteDiplomeModal.jsx"
import Date from "../../../../../shared/components/Moment/Date.jsx"
import FormTitleRow from "../../../../../shared/components/Styled/Form/FormTitleRow.jsx"
import ParagraphLeftAlign from "../../../../../shared/components/Styled/ParagraphLeftAlign.jsx"
import DivBlueBg from "../../../../../shared/components/Styled/Blocs/DivBlueBg.jsx"
import CertificationModal from "../../../../../shared/components/Modals/Certification/CertificationModal.jsx"
import LanguageModal from "../../../../../shared/components/Modals/Language/LanguageModal.jsx"
import ItSkillModal from "../../../../../shared/components/Modals/ItSkill/ItSkillModal.jsx"
import {
  CREATE_FREELANCE_STEPS,
  updateCreatFreelanceStep
} from "../../../../../shared/containers/Freelance/setNextStep.js"
import StrongSecondary from "../../../../../shared/components/Styled/Typography/StrongSecondary.jsx"
import {Col, Row} from "reactstrap"

import './presentation-step.scss'
import SecondaryButton from "../../../../../shared/components/Styled/Buttons/SecondaryButton.jsx"
import { isEqual } from '../../../../../shared/services/lodashInJS.js'


class Presentation extends PureComponent {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    freelance: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      degrees: this.sortChronologically(this.props.freelance?.diplomes?.length ? this.props.freelance.diplomes : []),
      certifications: this.sortChronologically(this.props.freelance?.certifications?.length ? this.props.freelance.certifications : []),
      itSkills: this.props.freelance?.it_skills?.length ? this.props.freelance.it_skills : [],
      languages: this.props.freelance?.languages?.length ? this.props.freelance.languages : [],
      languageLevels: Object.values(conf.languageLevels).reduce(
        (acc, curr) => {
          acc[curr.value] = curr.label
          return acc
        },
        []
      )
    }
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    const prevDegrees = prevProps.freelance?.diplomes?.length ? prevProps.freelance.diplomes : []
    const degrees = this.props.freelance?.diplomes?.length ? this.props.freelance.diplomes : []
    if (!isEqual(prevDegrees, degrees)) {
      this.setState({
        degrees: this.sortChronologically(degrees)
      })
    }
    const prevCertifications = prevProps.freelance?.certifications?.length ? prevProps.freelance.certifications : []
    const certifications = this.props.freelance?.certifications?.length ? this.props.freelance.certifications : []
    if (!isEqual(prevCertifications, certifications)) {
      this.setState({
        certifications: this.sortChronologically(certifications)
      })
    }
    const prevItSkills = prevProps.freelance?.it_skills?.length ? prevProps.freelance.it_skills : []
    const itSkills = this.props.freelance?.it_skills?.length ? this.props.freelance.it_skills : []
    if (!isEqual(prevItSkills, itSkills)) {
      this.setState({itSkills:this.sortChronologically( itSkills)})
    }
    const prevLanguages = prevProps.freelance?.languages?.length ? prevProps.freelance.languages : []
    const languages = this.props.freelance?.languages?.length ? this.props.freelance.languages : []
    if (!isEqual(prevLanguages, languages)) {
      this.setState({ languages })
    }
  }


  // Degrees
  sortChronologically = (degrees) => {
    return degrees
      .sort((a, b) => {
        const dateA = parseISO(a.year)
        const dateB = parseISO(b.year)
        if (dateA && dateB) {
          if (isAfter(dateA, dateB)) {
            return -1
          } else {
            return 1
          }
        } else {
          return 0
        }
      })
  }
  createNewDiplome = () => {
    this.props.openDiplomeModal({
      freelance: this.props.freelance,
      onSubmit: this.onModalSubmit,
    })
  }
  createNewCertification = () => {
    this.props.openCertificationModal({
      freelance: this.props.freelance,
      onSubmit: this.onModalSubmit,
    })
  }

  createNewItSkills = () => {
    this.props.openItSkillModal({
      freelance: this.props.freelance,
      onSubmit: this.onModalSubmit,
    })
  }

  createNewLanguage = () => {
    this.props.openLanguageModal({
      freelance: this.props.freelance,
      onSubmit: this.onModalSubmit,
    })
  }

  editExistingDiplome = (offset) => {
    return () => {
      this.props.openDiplomeModal({
        freelance: this.props.freelance,
        onSubmit: this.onModalSubmit,
        onClose: this.onCloseDiplome,
        offset
      })
    }
  }

  deleteDiplome = (offset) => {
    return () => {
      this.props.openDeleteDiplomeModal({
        freelance: this.props.freelance,
        onSubmit: this.onModalSubmit,
        offset
      })
    }
  }

  onCloseDiplome = (degrees) => {
    this.setState({degrees: this.sortChronologically(degrees)})
  }

  removeElementFrom = (field, offset) => {
    return async () => {
      const {freelance} = this.props
      const newValues = [...(freelance?.[field] ?? [])]
      newValues.splice(offset, 1)

      try {
        await this.onModalSubmit({
          freelance: {...freelance, [field]: newValues}
        })
      } catch (e) {
        console.warn(e)
      }
    }
  }

  goToStep = (step, payload) => {
    const {agent, ...freelanceData} = this.props.freelance
    updateCreatFreelanceStep(
      freelanceData.id,
      step,
      () => this.props.submit({
        freelance: payload || {...freelanceData},
        silentMode: true,
      })
    )
  }

  // Présentation
  onSubmit = (values) =>{
    const {
      languages,
      certifications,
      diplomes,
      it_skills,
      ...rest
    } = values.freelance

    this.props.submit({
      freelance: rest
    }).then((response) => {
      this.goToStep(CREATE_FREELANCE_STEPS.MISSIONS, rest)
    }).catch((errors) => {
      console.error({errors})
    })
  }

  onModalSubmit = (values) =>{
    this.props.submit({
      freelance: values.freelance
    }).catch((errors) => {
      console.error({errors})
    })
  }

  removeLanguage = (offset) => {
    return async () => {
      const {freelance} = this.props
      const languages = this.state.languages.length ? [...this.state.languages] : []

      try {
        const [removed] = languages.splice(offset, 1)
        await api.freelanceLanguages.delete({
          freelance: freelance.id,
          language: removed.language
        })
        this.setState({ languages })
      } catch (e) {
        console.warn(e)
      }
    }
  }

  goNextStep = () => {
    this.goToStep(CREATE_FREELANCE_STEPS.MISSIONS)
  }

  render() {
    const {currentUser, freelance} = this.props
    const { languages } = this.state

    return (
      <Fragment>
        <FormTitleRow className={'mb-4'} chip={1} text={'Présentation synthétique'}/>

        <DivBlueBg className="line-height-sm mb-4">
          <ParagraphLeftAlign className="mb-4">
            <StrongSecondary>
              Ceci est un exemple d'introduction, vous pouvez tout à fait revoir celle-ci à votre convenance.
              Attention à limiter celle-ci à une quinzaine de lignes : </StrongSecondary>
          </ParagraphLeftAlign>
          <ParagraphLeftAlign>
            Je capitalise XX années d'expériences professionnelle dans les achats/SCM/droit XXX années.
            J'ai évolué dans des environnements complexes/techniques/challengeant et suis intervenu principalement
            sur les catégories XXX.
          </ParagraphLeftAlign>
          <ParagraphLeftAlign>
            Ma personnalité dynamique, curieuse et organisée me permet de mener à bien plusieurs projets en
            parallèle.
          </ParagraphLeftAlign>
          <ParagraphLeftAlign className="mt-4" text="Exemples de projets :" />
          <ParagraphLeftAlign text="- Le pilotage et l'accompagnement des opérationnels dans la gestion de leur projets
            informatiques;"/>
          <ParagraphLeftAlign text="- La négociation juridique et financière de contrats de solutions avec des
            éditeurs;"/>
          <ParagraphLeftAlign text="- La gestion de contentieux informatiques;"/>
          <ParagraphLeftAlign text="- Etc."/>
        </DivBlueBg>

        <SummaryStepForm
          initialValues={{freelance, user: currentUser}}
          onSubmit={this.onSubmit}
          onSubmitSuccess={this.onSubmitSuccess}
        />

        {/* Formations*/}
        <FormTitleRow className={'mb-4'} chip={2} text={'Formations'}/>
        <div>
          <Row className={'presentation-row'}>
            <Col sm="12" md="6" >
              <p className="text-Left">
                Complétez ici votre parcours de formation et diplômes :
              </p>
            </Col>
            <Col sm="12" md="6" className="presentation-row-cta" >
              <button type="button" onClick={this.createNewDiplome} className="btn btn-outline-primary">
                <Plus/> Ajouter un diplôme / formation
              </button>
            </Col>
          </Row>

          {this.state.degrees.map((diplome, offset) => (
            <div className="callout callout-parcours" key={`degree-${offset}`}>
              <div className="controls">
                <div onClick={this.editExistingDiplome(offset)}
                  className="btn btn btn-outline-primary btn-round btn-sm">
                  <Edit/>
                </div>
                <div onClick={this.deleteDiplome(offset)} className="btn btn btn-outline-danger btn-round btn-sm">
                  <Trash/>
                </div>
              </div>
              {(diplome.name || diplome.year) &&
                <div>
                  {diplome.name && <b>{diplome.name}</b>}
                  {diplome.name && diplome.year && <span> - </span>}
                  {diplome.year && <Date format="yyyy" date={diplome.year}/>}
                </div>
              }
              <div className={(diplome.name) ? 'mt-2' : ''}>
                {nl2br(diplome.description)}
              </div>
            </div>
          ))}
        </div>

        {/* Certifications */}
        <FormTitleRow className={'mb-4'} chip={3} text={'Certifications'}/>

        <Row className={'presentation-row'}>
          <Col sm="12" md="6" >
            <p className="text-Left">
              Renseignez ici vos certifications :
            </p>
          </Col>
          <Col sm="12" md="6" className="presentation-row-cta" >
            <button type="button" onClick={this.createNewCertification} className="btn btn-outline-primary">
              <Plus/> Ajouter une certification
            </button>
          </Col>
        </Row>

        <div className="certifications mt-4">
          {this.state.certifications.map((certification, index) => (
            <div key={`certification-${certification.id}`} className="callout d-inline-block mr-3 mt-0 mb-3">
              <b>{certification.label}</b>
              {certification.date && <span> - <Date format="yyyy" date={certification.date}/></span>}
              <button
                onClick={this.removeElementFrom('certifications', index)}
                type="button"
                className="btn btn-round btn-sm btn-outline-danger ml-3"
              >
                <Trash/>
              </button>
            </div>
          ))}
        </div>

        {/* IT Skills */}
        <FormTitleRow className={'mb-4'} chip={4} text={'Outils et logiciels informatiques'}/>

        <Row className={'presentation-row'}>
          <Col sm="12" md="6" >
            <p className="text-Left">
              Outils et logiciels que vous maitrisez (ex: Excel, SAP, ARIBA, ...) :
            </p>
          </Col>
          <Col sm="12" md="6" className="presentation-row-cta" >
            <button type="button" onClick={this.createNewItSkills} className="btn btn-outline-primary">
              <Plus/> Ajouter un logiciel / outil
            </button>
          </Col>
        </Row>

        <div className="it_skills">
          {this.state.itSkills && <Fragment>
            {this.state.itSkills.map((itSkill, index) => (
              <div key={`it-skills-${itSkill.id}`} className="callout d-inline-block mr-3 mt-0 mb-3">
                <b>{itSkill.name}</b>
                <button
                  onClick={this.removeElementFrom('it_skills', index)}
                  type="button"
                  className="btn btn-round btn-sm btn-outline-danger ml-3"
                >
                  <Trash/>
                </button>
              </div>
            ))}
          </Fragment>}
        </div>

        {/* Languages */}
        <FormTitleRow className={'mb-4'} chip={5} text={'Langues'}/>

        <Row className={'presentation-row'}>
          <Col sm="12" md="8" >
            <p className="text-Left">
              Indiquez vos capacités à vous exprimer dans les langues que vous pratiquez :
            </p>
          </Col>
          <Col sm="12" md="4" className="presentation-row-cta" >
            <button type="button" onClick={this.createNewLanguage} className="btn btn-outline-primary">
              <Plus/> Ajouter
            </button>
          </Col>
        </Row>

        <div className="languages">
          {languages.map((language, index) => {
            return (
              <div key={`language-${index}`} className="callout d-inline-block mr-3 mt-0 mb-3">
                <b className="text-capitalize">{language.name}</b> - {this.state.languageLevels[language.level]}
                <button onClick={this.removeLanguage(index)} type="button"
                  className="btn btn-round btn-sm btn-outline-danger ml-3">
                  <Trash/>
                </button>
              </div>
            )})}
        </div>

        <Row >
          <Col sm="12" md="6" className="text-center mt-2">
            <SecondaryButton onClick={this.goNextStep}> Retourner aux instructions </SecondaryButton>
          </Col>
          <Col sm="12" md="6" className="text-center mt-2">
            <SummaryStepSubmit className="mx-auto btn btn-primary">Valider</SummaryStepSubmit>
          </Col>
        </Row>

      </Fragment>
    )
  }
}

export default connectModal({DiplomeModal, DeleteDiplomeModal, CertificationModal, LanguageModal, ItSkillModal}, Presentation)
